import { enqueueSnackbar } from "notistack"
import { api } from "../../api"
import { setAlertFunc } from "../../components/AlertToaster/AlertSlice"
import { HistoryResponse, tagsDetail } from "../Common/commonTypes"

export type tagsObj = {
    other: tagsDetail[]
    primary: tagsDetail[]
}
export type SitesObj = {
    added_by: string
    address: string
    city: string
    city_id: number
    created_at: string
    id: number
    is_active: number
    is_warehouse: 0 | 1
    latitude: number
    longitude: number
    name: string
    pincode: number
    site_id: string
    site_type: string
    state: string
    state_id: number
    updated_at: null
    linked_projects: any
    total_linked_count: number
    country_id: number
    csms_station_id: number
    tags?: {
        others: tagsDetail[]
        primary: tagsDetail[]
    }
}

export type SitesDataObj = {
    added_by: string
    address: string
    city: string
    city_id: number
    created_at: string
    id: number
    is_active: number
    is_warehouse: 0 | 1
    latitude: number
    longitude: number
    name: string
    pincode: number
    site_id: string
    is_station: 0 | 1
    state: string
    state_id: number
    updated_at: null
    linked_projects: any
    total_linked_count: number
    map_link: string
    country_id: number
    csms_station_id: number
    tag_info?: tagsObj
    onboarding_date: string
    status: string
    cpo: string
    host: string
    source: string
    decapitalization_date: string
    capitalization_date: string
    capitalization_status: string
    ownership_status: string
}

export type SiteListPayload = {
    page: number
    per_page: number
    site?: string // Search term for site name
    pincode?: string
    added_by?: number[] | string
    state?: number[] | string
    city?: number[] | string
    status?: number | ""
    site_type?: string
    updated_at?: boolean
    created_at?: any
    showOnlyActive?: boolean
    country_id?: number
    tag_ids?: number[] | string
    download?: boolean
    warehouse_sort?: boolean
    site_id?: number[]
}
export type SiteDataPayload = {
    page: number
    page_size?: number
    site_name?: string
    pincode?: string
    added_by?: number[] | string
    state?: number[] | string
    city?: number[] | string
    site_type?: string
    download?: boolean
    country?: number
    added_on?: string
    added_from?: string
    added_to?: string
    capitalization_status?: number[] | string
    ownership_status?: number[] | string
    cpo?: number[] | string
    host?: number[] | string
    tags?: number[] | string
    is_onboarded?: number
    parking_type?: number[] | string
    vehicle_type?: number[] | string
    is_station?: number
    age: any[]
    age_op: string
    is_active: 0 | 1
    site_status: number[] | string
    dfc_approval_status?: string
    is_warehouse?: 0 | 1
}
export type SiteChargerObj = {
    charger_id?: number
    charger_name: string
    charger_type: string
    is_demolished?: 0 | 1
    oem: string | null
    serial_cin: string | null
    sku_code: string | null
    operational_status: string | null
}

export type SiteTicketChargerObj = {
    capitalization_date: string | null
    capitalization_status: string | null
    charger_id: number
    cin: string | null
    commissioning_date: string | null
    decapitalization_date: string | null
    decommissioning_date: string | null
    display_id: string
    go_live_date: string | null
    investors: string | null
    is_offloaded: boolean
    item_description: string
    plp_id: number
    oem: string | null
    operational_status: number | null
    project_id: number | null
    project_name: string | null
    received_on: string | null
    rev_invoice_number: string | null
    sku: string | null
    status: string | null
}

export type SiteMaterialObj = {
    capitalization_date: string | null
    capitalization_status: string | null
    plp_id: number
    close_date: string | null
    dc_amount: string | null
    file_url: string | null
    decapitalization_date: string | null
    destination_site_id: string | null
    destination_site_name: string | null
    display_id: string
    from_site_id: string | null
    from_site_name: string | null
    installed_date: string | null
    dc_invoice_number: string | null
    item_description: string | null
    logistic_create_date: string | null
    logistic_status: string | null
    logistic_id: number | null
    oem: string | null
    opr_status: string | null
    project_id: number | null
    project_name: string | null
    quantity: number | null
    sent_on: string | null
    sku_code: string | null
    source_site_id: string | null
    source_site_name: string | null
    to_site_name: string | null
}

export type ConnectionExpenseObj = {
    capitalization_date: string
    capitalization_status: string
    decapitalization_date: string
    discom_name: string
    item_category: string
    item_type: string
    non_refundable_amount: string
    payment_date: string
    payment_status: string
    refundable_amount: string
    total_amount: number
    utr_number: string
    vp_id: number
    vt_id: number
}

export type VendorBillObj = {
    vpt_id: number
    project_id: number | null
    project: string | null
    ticket_id: number | null
    vendor: string | null
    invoice_number: string | null
    invoice_date: string | null
    bill_upload_date: string | null
    module: string | null
    module_id: number | null
    sub_module_id: number | null
    bill_amount: string | null
    gst_amount: string | null
    total_amount: string | null
    amount_paid: string | null
    payment_status: string | null
    payment_date: string | null
    utr_number: string | null
    capitalization_status: string | null
    capitalization_date: string | null
    decapitalization_date: string | null
}

export type CapitalizationSummary = {
    capitalization_date: string
    capitalization_status: string
    capitalized_amount: string
    total_amount: string
}
export type SiteAssetObj = {
    asset_id: number
    description: string
    item_type: string
    operational_status: string
    operational_status_id: number
    quantity: number | null
    serial_number: string | null
    sku_code: string
    create_date: string
    commissioned_date: string | null
    delivered_date: string | null
    installed_date: string | null
    grn_date: string | null
    grn_done_by: string | null
    grn_status: string | null
    grn_documents: string[]
    investor_names: string[]
    investor_offloaded: boolean
    color_code: string | null
}
export type GetSiteAssetsResponse = {
    data: SiteAssetObj[]
    tab: string
    total: number
}
export type MeterDetails = {
    end_date: string | null
    installed_by: string | null
    meter_image: any
    meter_number: string | null
    meter_start_reading: string | null
    owned_by: string | null
}

export type SiteConnectionObj = {
    application_date: string | null
    application_number: string | null
    applied_load: string | null
    color_code: string
    connection_account_number: string | null
    discom_name: string | null
    display_id: string
    energization_date: string | null
    ev_application_status: string
    ev_connection_status: "Active" | "Inactive"
    id: number
    is_substation_installed: boolean
    meter_details: MeterDetails
    non_refundable_amount: number
    owned_by: string | null
    refundable_amount: number
    status_id: number
    text_color_code: string
}
export type DealDetails = {
    deal_amount?: number | null
    deal_amount_esc?: number | null
    license_fee_ac?: number | null
    license_fee_dc?: number | null
    deal_term?: number | null
    profit_share?: number | null
    rental?: number | null
    revenue_share?: number | null
    start_date?: string | null
    end_date?: string | null
}

export type SiteStakeholderObj = {
    account_id: number
    account_name: string
    atpm_id: number
    deal_details: DealDetails | null
    role: string
    validity_from: string | null
    validity_to: string | null
}

export type UpdateSiteStakeholderValidityPayload = {
    atpm_id: number
    account_id: number
    validity_from: string
    validity_to: string
}

export type GetSiteStakeholderResponse = {
    data: SiteStakeholderObj[]
}
const MODULE_URL = `sites`
const MODULE_URL_2 = `site`

const SiteService = api.injectEndpoints({
    endpoints: build => ({
        getAllSites: build.query<{ data: SitesObj[]; totalPages: number }, SiteListPayload>({
            query: ({ showOnlyActive, ...params }) => ({
                url: `${MODULE_URL}/site_operations`,
                params: {
                    ...params,
                    country_id: params?.country_id ?? "",
                },
                useV3: true,
            }),
            transformResponse: (
                response: { data: SitesObj[]; totalPages: number },
                meta: any,
                args: SiteListPayload
            ) => {
                if (args?.showOnlyActive === false) {
                    return response
                }
                return {
                    data: response.data.filter((site: SitesObj) => site.is_active === 1),
                    totalPages: response.totalPages,
                }
            },
            providesTags: ["Sites"],
        }),
        getSitesData: build.query<{ data: SitesDataObj[]; total_pages: number; total_count: number }, SiteDataPayload>({
            query: ({ ...params }) => ({
                url: `${MODULE_URL_2}/list`,
                useV3: true,
                params: {
                    ...params,
                },
            }),
            providesTags: ["Sites"],
        }),
        getDownloadSitesData: build.query<
            { data: SitesDataObj[]; total_pages: number; total_count: number },
            SiteDataPayload
        >({
            query: ({ ...params }) => ({
                url: `${MODULE_URL_2}/download`,
                useV3: true,
                params: {
                    ...params,
                },
            }),
            providesTags: ["Sites"],
        }),
        getSiteTicketHistory: build.query<
            { data: HistoryResponse[]; totalPages: number },
            { site_id: string; page: number; per_page: number }
        >({
            query: params => ({
                url: `${MODULE_URL}/history`,
                params: params,
            }),
            providesTags: (result, error, arg) => [{ type: "Sites", id: arg.site_id }],
        }),
        getSiteHistory: build.query<HistoryResponse, { site_id: string }>({
            query: ({ site_id }) => ({
                url: `${MODULE_URL_2}/history`,
                useV3: true,
                params: { site_id },
            }),
            providesTags: ["Sites"],
        }),
        getAddedByForSites: build.query<{ id: number; user_name: string }[], void>({
            query: () => ({
                url: `${MODULE_URL}/list_added_by`,
            }),
            providesTags: ["Sites"],
        }),
        getChargersBySiteId: build.query<SiteChargerObj[], { site_id: string }>({
            query: ({ site_id }) => ({
                url: `chargers_by_site_id`,
                params: {
                    site_id,
                },
            }),
            providesTags: ["Sites"],
        }),
        getSiteItems: build.query<any, { site_id: string; delivered_filter?: boolean }>({
            query: ({ site_id, delivered_filter = false }) => ({
                url: `${MODULE_URL}/site_items`,
                params: {
                    site_id,
                    delivered_filter,
                },
            }),
            providesTags: ["Sites", "Demolition"],
        }),
        getSiteTicketDetail: build.query<any, { site_id: string }>({
            query: ({ site_id }) => ({
                url: `${MODULE_URL_2}/details`,
                params: {
                    site_id,
                },
                useV3: true,
            }),
            providesTags: ["Sites"],
        }),
        getSiteStatus: build.query<{ id: number; title: string }[], void>({
            query: () => ({
                url: `${MODULE_URL_2}/status_list`,
                useV3: true,
            }),
        }),
        getSiteStakeholder: build.query<GetSiteStakeholderResponse, { site_id: string }>({
            query: ({ site_id }) => ({
                url: `${MODULE_URL_2}/stakeholders`,
                params: {
                    site_id,
                },
                useV3: true,
            }),
            providesTags: ["Sites"],
        }),
        getSiteProjects: build.query<any, { site_id: string }>({
            query: ({ site_id }) => ({
                url: `${MODULE_URL_2}/projects`,
                params: {
                    site_id,
                },
                useV3: true,
            }),
        }),
        getSiteAssets: build.query<GetSiteAssetsResponse, { site_id: string; is_download?: boolean; tab: string }>({
            query: ({ site_id, is_download, tab }) => ({
                url: `${MODULE_URL_2}/assets`,
                params: {
                    site_id,
                    is_download: is_download ? is_download : false,
                    tab: tab,
                },
                useV3: true,
            }),
        }),
        getSiteConnections: build.query<SiteConnectionObj[], { site_id: string }>({
            query: ({ site_id }) => ({
                url: `${MODULE_URL_2}/connection`,
                params: {
                    site_id,
                },
                useV3: true,
            }),
            providesTags: ["Sites"],
        }),
        getSiteTickets: build.query<
            any,
            {
                site_id: number
                module_id?: string
                submodule_id?: string
                status_id?: string
                assigned_to?: string
            }
        >({
            query: params => ({
                url: `${MODULE_URL_2}/tickets`,
                params,
                useV3: true,
            }),
        }),
        getSiteChargers: build.query<SiteTicketChargerObj[], { site_id: string; opr_status?: number }>({
            query: params => ({
                url: `site/chargers`,
                useV3: true,
                params,
            }),
            providesTags: ["Sites"],
        }),
        getSiteMaterials: build.query<
            SiteMaterialObj[] | Record<string, SiteMaterialObj[]>,
            { site_id: string; grp_key?: "project" }
        >({
            query: params => ({
                url: `site/materials`,
                useV3: true,
                params,
            }),
            transformResponse: (response: any, _meta, args): SiteMaterialObj[] | Record<string, SiteMaterialObj[]> => {
                const data = response?.data ?? response
                if (args.grp_key === "project") {
                    return data as Record<string, SiteMaterialObj[]>
                }
                return data as SiteMaterialObj[]
            },
            providesTags: ["Sites"],
        }),
        getCapitalizationSummary: build.query<CapitalizationSummary, { site_id: string }>({
            query: params => ({
                url: `site/capitalization_summary`,
                useV3: true,
                params,
            }),
            providesTags: ["Sites"],
        }),
        getConnectionExpense: build.query<ConnectionExpenseObj[], { site_id: string }>({
            query: params => ({
                url: `site/connection_expense`,
                useV3: true,
                params,
            }),
            providesTags: ["Sites"],
        }),
        getVendorBills: build.query<VendorBillObj[], { site_id: string }>({
            query: params => ({
                url: `site/vendor_bills`,
                useV3: true,
                params,
            }),
            providesTags: ["Sites"],
        }),
        // Mutations
        addSiteTicket: build.mutation<{ msg: string }, any>({
            query: body => ({
                url: `${MODULE_URL}/site_operations`,
                method: "POST",
                body: body,
            }),
            onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data?.msg }))
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error?.msg }))
                }
            },
            invalidatesTags: ["Sites"],
        }),
        editSiteTicket: build.mutation<{ msg: string }, any>({
            query: body => ({
                url: `${MODULE_URL}/site_operations`,
                method: "PUT",
                body: body,
            }),
            onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data?.msg }))
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error?.msg }))
                }
            },
            invalidatesTags: ["Sites"],
        }),

        editEvConnectionStatus: build.mutation<
            { msg: string },
            { ticket_id: number; connection_status: "Active" | "Inactive" }
        >({
            query: body => ({
                url: `${MODULE_URL_2}/connection`,
                method: "PUT",
                body,
                useV3: true,
            }),
            onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data.msg }))
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error?.message }))
                }
            },
            invalidatesTags: ["Sites"],
        }),
        editSiteStatus: build.mutation<{ msg: string }, { site_id: number; status: 0 | 1 }>({
            query: body => ({
                url: `${MODULE_URL}/site_operations`,
                method: "DELETE",
                body,
            }),
            onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data.msg }))
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error?.message }))
                }
            },
            invalidatesTags: ["Sites"],
        }),
        addSiteImages: build.mutation<{ message: string }, FormData>({
            query: body => ({
                url: `${MODULE_URL_2}/upload_images`,
                method: "PUT",
                useV3: true,
                body: body,
            }),
            onQueryStarted: async (args, { queryFulfilled }) => {
                try {
                    const { data } = await queryFulfilled
                    if (args.get("del_ids")) {
                        enqueueSnackbar("Image deleted successfully", { variant: "success" })
                    } else enqueueSnackbar(data?.message, { variant: "success" })
                } catch (error: any) {
                    enqueueSnackbar(error?.message, { variant: "error" })
                }
            },
            invalidatesTags: ["Sites"],
        }),
        editPlpCapitalizationStatus: build.mutation<
            { message: string },
            {
                plp_id: number
                old_status: string | null
                new_status: string
                module_id: number
                submodule_id: number
                date_val?: string | null
            }
        >({
            query: body => ({
                url: `site/plp_capitalization`,
                method: "PUT",
                useV3: true,
                body,
            }),
            onQueryStarted: async (_, { queryFulfilled }) => {
                try {
                    const { data } = await queryFulfilled
                    enqueueSnackbar(data.message, { variant: "success" })
                } catch (error: any) {
                    enqueueSnackbar(error?.error?.data?.error?.[0] || "Something went wrong!", { variant: "error" })
                }
            },
            invalidatesTags: ["Sites"],
        }),
        updateSiteStakeholderValidity: build.mutation<{ message: string }, UpdateSiteStakeholderValidityPayload>({
            query: body => ({
                url: `${MODULE_URL_2}/stakeholders`,
                method: "PUT",
                useV3: true,
                body,
            }),
            onQueryStarted: async (_, { queryFulfilled }) => {
                try {
                    const { data } = await queryFulfilled
                    enqueueSnackbar(data.message, { variant: "success" })
                } catch (error: any) {
                    enqueueSnackbar(error?.error?.data?.error?.[0] || "Something went wrong!", { variant: "error" })
                }
            },
            invalidatesTags: ["Sites"],
        }),
        editVptCapitalizationStatus: build.mutation<
            { message: string },
            {
                ticket_id: number
                vpt_id: number
                old_status: string | null
                new_status: string
                module_id: number
                submodule_id: number
                date_val?: string | null
            }
        >({
            query: body => ({
                url: `site/vpt_capitalization`,
                method: "PUT",
                useV3: true,
                body,
            }),
            invalidatesTags: ["Sites"],
            onQueryStarted: async (_, { queryFulfilled }) => {
                try {
                    const { data } = await queryFulfilled
                    enqueueSnackbar(data.message, { variant: "success" })
                } catch (error: any) {
                    enqueueSnackbar(error?.error?.data?.error?.[0] || "Something went wrong!", { variant: "error" })
                }
            },
        }),
    }),
})

export const {
    useLazyGetAllSitesQuery,
    useLazyGetSitesDataQuery,
    useLazyGetDownloadSitesDataQuery,
    useGetAddedByForSitesQuery,
    useGetChargersBySiteIdQuery,
    useGetSiteTicketDetailQuery,
    useGetSiteStatusQuery,
    useLazyGetSiteTicketHistoryQuery,
    useGetSiteItemsQuery,
    useGetSiteConnectionsQuery,
    useLazyGetSiteAssetsQuery,
    useGetSiteStakeholderQuery,
    useLazyGetSiteTicketsQuery,
    useGetSiteProjectsQuery,
    useGetSiteAssetsQuery,
    useAddSiteImagesMutation,
    useGetSiteChargersQuery,
    useAddSiteTicketMutation,
    useEditSiteTicketMutation,
    useEditSiteStatusMutation,
    useGetCapitalizationSummaryQuery,
    useGetConnectionExpenseQuery,
    useEditEvConnectionStatusMutation,
    useGetVendorBillsQuery,
    useGetSiteMaterialsQuery,
    useEditPlpCapitalizationStatusMutation,
    useEditVptCapitalizationStatusMutation,
    useGetSiteHistoryQuery,
    useUpdateSiteStakeholderValidityMutation,
} = SiteService

export { SiteService }
